import { Meeting_Step_Type_Enum } from '@gql'
import {
  ChecklistIcon,
  IndicatorsIcon,
  MeetingStepDeclusionIcon,
  MeetingStepInclusionIcon,
  MeetingStepNextStepsIcon,
  MeetingStepThreadsGovernanceIcon,
  MeetingStepThreadsIcon,
  NoteIcon,
  TaskIcon,
} from 'src/icons'

// Ordered like a meeting unfolds, not like the types were added: opening,
// content, closing. That arc is what keeps a flat menu readable — you read it
// in the order you would build the meeting. "Free note" comes last on purpose:
// it belongs to no moment, it is the catch-all for when none of the above fits.
export const stepsAndIcons = [
  {
    type: Meeting_Step_Type_Enum.Inclusion,
    icon: MeetingStepInclusionIcon,
  },
  {
    type: Meeting_Step_Type_Enum.Checklist,
    icon: ChecklistIcon,
  },
  {
    type: Meeting_Step_Type_Enum.Indicators,
    icon: IndicatorsIcon,
  },
  {
    type: Meeting_Step_Type_Enum.Tasks,
    icon: TaskIcon,
  },
  // The two thread steps sit next to each other on purpose: they are read as a
  // pair, and the second only makes sense against the first.
  {
    type: Meeting_Step_Type_Enum.Threads,
    icon: MeetingStepThreadsIcon,
  },
  {
    type: Meeting_Step_Type_Enum.ThreadsGovernance,
    icon: MeetingStepThreadsGovernanceIcon,
  },
  // After the two tension steps and before the closing round: a meeting
  // triages its tensions, then reviews what they produced (G2-D16).
  {
    type: Meeting_Step_Type_Enum.NextSteps,
    icon: MeetingStepNextStepsIcon,
  },
  {
    type: Meeting_Step_Type_Enum.Declusion,
    icon: MeetingStepDeclusionIcon,
  },
  {
    type: Meeting_Step_Type_Enum.Tour,
    icon: NoteIcon,
  },
]
